import { MutationPayload } from 'vuex';
import { modalTip } from '../ModalTip';

export default (mutation: MutationPayload, state: any) => {

  try {
    const type = mutation.type;
    if (type.endsWith('_FAILED')) {
      const payload = mutation.payload;
      if (payload) {
        if (payload.err && payload.err.code === 'ECONNABORTED') {
          modalTip.error({
            message: '网络连接超时,请刷新页面重试',
            name: '网络连接超时,请刷新页面重试',
            code: payload.err.code || 0
          });

        } else if (payload.err && payload.err.message === 'Network Error') {
          modalTip.error({
            message: '服务调用异常,请刷新页面重试',
            name: '服务调用异常,请刷新页面重试',
            code: payload.err.code || 0
          });
        } else if (payload.err && payload.err.code === 500) {
          modalTip.error({
            name: payload.res.data.message
              ? payload.res.data.message
              : '服务调用异常,请刷新页面重试',
            message: payload.res.data.name
              ? payload.res.data.name
              : '服务调用异常,请刷新页面重试',
            code: payload.res.code || 0
          });
        } else if (payload.res && payload.res.code === 500) {
          modalTip.error({
            name: payload.res.data.message
              ? payload.res.data.message
              : '服务调用异常,请刷新页面重试',
            message: payload.res.data.name
              ? payload.res.data.name
              : '服务调用异常,请刷新页面重试',
            code: payload.res.code || 0
          });
        } else {
          modalTip.error({
            message:
              (payload.res &&
                (payload.res.Data
                  ? payload.res.Data.code
                  : payload.res.Message)) ||
              '服务调用异常,请刷新页面重试',
            name:
              (payload.res && payload.res.Data) ||
              (payload.res && payload.res.Message) ||
              '服务调用异常,请刷新页面重试',
            code: payload.code || 0
          });
        }
      }
    }
  } catch (err) {    
    modalTip.error({
      message: '页面异常',
      name: err.message,
      code: 10001
    });
  }
};
